<template>
<SliderComponent/>
<ServicesSection/>
</template>

<script>
  import SliderComponent from "@/components/home/SliderComponent.vue";
  import ServicesSection from "@/components/home/ServicesSection.vue";
  export default {
    name: 'HomeView',
    components:{SliderComponent, ServicesSection,},
    beforeCreate(){
      console.log('Before Create!');
    },
    created(){
      document.title = 'Home';
      console.log('Created!');
    },
    beforeMount(){
      console.log('Before Mount!');
    },
    mounted(){
      console.log('Mounted!');
    },
    beforeUpdate(){
      console.log('Before Update!');
    },
    updated(){
      console.log('Updated!');
    },
    beforeUnmount(){
      console.log('Before Unmount!');
    },
    unmounted(){
      console.log('Unmounted!');
    },
  }
</script>

<style></style>
